import { strings } from 'APP_ROOT/localization';
import { RESOURCE_GROUP_TYPES } from './../../components/pages/dashboard/ResourceGroups/constants';

export const ACTIVE_MENU_ITEM_IDS = { // for main and user menus
    DASHBOARD_VEHICLE: "DASHBOARD_VEHICLE", // for now, since vehicle, geofence, and asset all use the same dasboard, each one is prefixed with DASHBOARD_
    DASHBOARD_GEOFENCE: "DASHBOARD_GEOFENCE",
    DASHBOARD_ASSET: "DASHBOARD_ASSET",
    HISTORY_TRIP_REVIEW: "HISTORY_TRIP_REVIEW",
    HISTORY_EVENT_REVIEW: "HISTORY_EVENT_REVIEW",
    HISTORY_SAFETY_SCORE: "HISTORY_SAFETY_SCORE",
    REPORTS_TRIP: "REPORTS_TRIP",
    REPORTS_ACTIVITY: "REPORTS_ACTIVITY",
    REPORTS_EVENT: "REPORTS_EVENT",
    REPORTS_GEOFENCE: "REPORTS_GEOFENCE",
    REPORTS_RAVEN: "REPORTS_RAVEN",
    REPORTS_ASSET: "REPORTS_ASSET",
    REPORTS_DTC: "REPORTS_DTC",
    REPORTS_STOPS: "REPORTS_STOPS",
    SETTINGS: "SETTINGS",
    ACCOUNT: "ACCOUNT",
    ACCOUNT_RAVENS: "ACCOUNT_RAVENS",
    ACCOUNT_USERS: "ACCOUNT_USERS",
    ACCOUNT_TAGS: "ACCOUNT_TAGS",
    ACCOUNT_BEACONS: "ACCOUNT_BEACONS",
    ACCOUNT_PROFILE: "ACCOUNT_PROFILE",
    GRID: "GRID",
};

// Inspired by the Ducks Modular Redux proposal https://github.com/erikras/ducks-modular-redux
// However, the groupings by object are carried over from globalsettings (../globalsettings/index.js) (written before I knew about Ducks)

// Redux Store Action Types (i.e., just their names)
export const ACTION_TYPES = {
    SET_MAIN_NAVIGATION_IS_COLLAPSED: "raven-webapp/layoutTemplateModularFullscreen/SET_MAIN_NAVIGATION_IS_COLLAPSED",
    SET_MAIN_NAVIGATION_ACTIVE_MENU_ITEM_ID: "raven-webapp/layoutTemplateModularFullscreen/SET_MAIN_NAVIGATION_ACTIVE_MENU_ITEM_ID",
    SET_MAIN_MODULE_GROUP_NAVIGATION_TITLE: "raven-webapp/layoutTemplateModularFullscreen/SET_MAIN_MODULE_GROUP_NAVIGATION_TITLE",
    SET_MAIN_MODULE_GROUP_NAVIGATION_IS_COLLAPSED: "raven-webapp/layoutTemplateModularFullscreen/SET_MAIN_MODULE_GROUP_NAVIGATION_IS_COLLAPSED",
    SET_MAIN_MODULE_GROUP_DETAILS_TITLE: "raven-webapp/layoutTemplateModularFullscreen/SET_MAIN_MODULE_GROUP_DETAILS_TITLE",
    SET_MAIN_MODULE_GROUP_DETAILS_IS_COLLAPSED: "raven-webapp/layoutTemplateModularFullscreen/SET_MAIN_MODULE_GROUP_DETAILS_IS_COLLAPSED",
    SET_MAIN_MODULE_GROUP_SELECTED_RESOURCE_TYPE: "raven-webapp/layoutTemplateModularFullscreen/SET_MAIN_MODULE_GROUP_SELECTED_RESOURCE_TYPE",
    SET_MAIN_NAVIGATION_ACTIVE_MENU_ITEM_DOM_ELEMENT_TOP: "raven-webapp/layoutTemplateModularFullscreen/SET_MAIN_NAVIGATION_ACTIVE_MENU_ITEM_DOM_ELEMENT_TOP",
    SET_FULLSCREEN_MODE: "raven-webapp/layoutTemplateModularFullscreen/SET_FULLSCREEN_MODE"
}

const layoutTemplateModularFullscreenInitialState = { // used during init and resets

    mainNavigationIsCollapsed: false,
    mainNavigationActiveMenuItemId: undefined,
    mainModuleGroupNavigationTitle: strings.resource_group_title_vehicles,
    mainModuleGroupNavigationIsCollapsed: true, // init as false since tablet/mobile mode requires them to be visible
    mainModuleGroupDetailsTitle: strings.vehicle_details_title,
    mainModuleGroupDetailsIsCollapsed: true,
    mainModuleGroupSelectedResourceType: "vehicle",
    mainNavigationActiveMenuItemDomElementTop: 0,
    fullscreenModeIsActive: false
}

// Redux Store Actions (i.e., functions that just return objects with specific "type" properties with ACTION_TYPES values and corresponding payloads with keys/values used to perform the ACTION_TYPE in the corresponding reducer)
export const ACTIONS = {

    setMainNavigation: (isCollapsed) => {
        return {
            type: ACTION_TYPES.SET_MAIN_NAVIGATION_IS_COLLAPSED,
            payload: {
                mainNavigationIsCollapsed: isCollapsed
            }
        }
    },

    setMainNavigationActiveMenuItemId: (activeMenuItemId) => {

        let allMenuStatesForActiveMenuItemId = {
            mainNavigationActiveMenuItemId: activeMenuItemId,
            // default is to reset the other menu states
            mainModuleGroupSelectedResourceType: layoutTemplateModularFullscreenInitialState.mainModuleGroupSelectedResourceType,
            mainModuleGroupNavigationTitle: layoutTemplateModularFullscreenInitialState.mainModuleGroupNavigationTitle,
            mainModuleGroupDetailsTitle: layoutTemplateModularFullscreenInitialState.mainModuleGroupDetailsTitle,
            mainModuleGroupNavigationIsCollapsed: layoutTemplateModularFullscreenInitialState.mainModuleGroupNavigationIsCollapsed,
            mainModuleGroupDetailsIsCollapsed: layoutTemplateModularFullscreenInitialState.mainModuleGroupDetailsIsCollapsed
        };
        // override default resets based on activeMenuItemId
        switch(activeMenuItemId) {
            case ACTIVE_MENU_ITEM_IDS.DASHBOARD_ASSET:
                allMenuStatesForActiveMenuItemId.mainModuleGroupSelectedResourceType = RESOURCE_GROUP_TYPES.ASSET;
                allMenuStatesForActiveMenuItemId.mainModuleGroupNavigationTitle = strings.resource_group_title_assets;
                allMenuStatesForActiveMenuItemId.mainModuleGroupDetailsTitle = strings.asset_details_title;
                allMenuStatesForActiveMenuItemId.mainModuleGroupNavigationIsCollapsed = false;
                allMenuStatesForActiveMenuItemId.mainModuleGroupDetailsIsCollapsed = false;
                break;
            case ACTIVE_MENU_ITEM_IDS.DASHBOARD_GEOFENCE:
                allMenuStatesForActiveMenuItemId.mainModuleGroupSelectedResourceType = RESOURCE_GROUP_TYPES.GEOFENCE;
                allMenuStatesForActiveMenuItemId.mainModuleGroupNavigationTitle = strings.geofences_geofences_title;
                allMenuStatesForActiveMenuItemId.mainModuleGroupDetailsTitle = strings.geofences_details_title;
                allMenuStatesForActiveMenuItemId.mainModuleGroupNavigationIsCollapsed = false;
                allMenuStatesForActiveMenuItemId.mainModuleGroupDetailsIsCollapsed = false;
                break;
            case ACTIVE_MENU_ITEM_IDS.DASHBOARD_VEHICLE:
                allMenuStatesForActiveMenuItemId.mainModuleGroupSelectedResourceType = RESOURCE_GROUP_TYPES.VEHICLE;
                allMenuStatesForActiveMenuItemId.mainModuleGroupNavigationTitle = strings.resource_group_title_vehicles;
                allMenuStatesForActiveMenuItemId.mainModuleGroupDetailsTitle = strings.vehicle_details_title;
                allMenuStatesForActiveMenuItemId.mainModuleGroupNavigationIsCollapsed = false;
                allMenuStatesForActiveMenuItemId.mainModuleGroupDetailsIsCollapsed = false;
                break;
            case ACTIVE_MENU_ITEM_IDS.GRID:
                allMenuStatesForActiveMenuItemId.mainModuleGroupNavigationTitle = strings.grid_filter;
                allMenuStatesForActiveMenuItemId.mainModuleGroupDetailsTitle = strings.action_details;
                break;
            case ACTIVE_MENU_ITEM_IDS.HISTORY_TRIP_REVIEW:
                allMenuStatesForActiveMenuItemId.mainModuleGroupNavigationTitle = strings.history;
                allMenuStatesForActiveMenuItemId.mainModuleGroupDetailsTitle = strings.action_details;
                allMenuStatesForActiveMenuItemId.mainModuleGroupNavigationIsCollapsed = false;
                allMenuStatesForActiveMenuItemId.mainModuleGroupDetailsIsCollapsed = false;
                break;
            case ACTIVE_MENU_ITEM_IDS.HISTORY_SAFETY_SCORE:
                allMenuStatesForActiveMenuItemId.mainModuleGroupNavigationTitle = strings.history_safety_scare_main_module_group_nav_title;
                allMenuStatesForActiveMenuItemId.mainModuleGroupDetailsTitle = strings.action_details;
                break;
            case ACTIVE_MENU_ITEM_IDS.HISTORY_EVENT_REVIEW:
                allMenuStatesForActiveMenuItemId.mainModuleGroupNavigationTitle = strings.filter_options;
                allMenuStatesForActiveMenuItemId.mainModuleGroupNavigationIsCollapsed = false;
                allMenuStatesForActiveMenuItemId.mainModuleGroupDetailsIsCollapsed = false;
                break;
            case ACTIVE_MENU_ITEM_IDS.REPORTS_ACTIVITY:
            case ACTIVE_MENU_ITEM_IDS.REPORTS_TRIP:
            case ACTIVE_MENU_ITEM_IDS.REPORTS_EVENT:
            case ACTIVE_MENU_ITEM_IDS.REPORTS_GEOFENCE:
            case ACTIVE_MENU_ITEM_IDS.REPORTS_RAVEN:
            case ACTIVE_MENU_ITEM_IDS.REPORTS_DTC:
            case ACTIVE_MENU_ITEM_IDS.REPORTS_STOPS:
            case ACTIVE_MENU_ITEM_IDS.REPORTS_ASSET:
            case ACTIVE_MENU_ITEM_IDS.SETTINGS:
            case ACTIVE_MENU_ITEM_IDS.ACCOUNT:
            case ACTIVE_MENU_ITEM_IDS.ACCOUNT_USERS:
            case ACTIVE_MENU_ITEM_IDS.ACCOUNT_RAVENS:
            case ACTIVE_MENU_ITEM_IDS.ACCOUNT_TAGS:
            case ACTIVE_MENU_ITEM_IDS.ACCOUNT_BEACONS:
            case ACTIVE_MENU_ITEM_IDS.ACCOUNT_PROFILE:
                allMenuStatesForActiveMenuItemId.mainNavigationIsCollapsed = false; // ensure the main menu is expanded (if user navigates to these sections somehow while main nav is collapsed)
                // keep current defaults in allMenuStatesForActiveMenuItemId
                break;
            default:
                // keep current defaults, but squawk in the console:
                console.error("layoutTemplateModularFullscreen duck setMainModuleGroupSelectedResourceGroupType unrecognized activeMenuItemId", activeMenuItemId);
                break;
        }
        return {
            type: ACTION_TYPES.SET_MAIN_NAVIGATION_ACTIVE_MENU_ITEM_ID,
            payload: {
                allMenuStatesForActiveMenuItemId: allMenuStatesForActiveMenuItemId
            }
        }
    },

    setMainModuleGroupNavigationTitle: (title) => {

        return {
            type: ACTION_TYPES.SET_MAIN_MODULE_GROUP_NAVIGATION_TITLE,
            payload: {
                mainModuleGroupNavigationTitle: title
            }
        }
    },

    setMainModuleGroupNavigation: (isCollapsed) => {
        return {
            type: ACTION_TYPES.SET_MAIN_MODULE_GROUP_NAVIGATION_IS_COLLAPSED,
            payload: {
                mainModuleGroupNavigationIsCollapsed: isCollapsed
            }
        }
    },

    setMainModuleGroupSelectedResourceType: (resourceType) => {
        return {
            type: ACTION_TYPES.SET_MAIN_MODULE_GROUP_SELECTED_RESOURCE_TYPE,
            payload: {
                mainModuleGroupSelectedResourceType: resourceType
            }
        }
    },

    setMainModuleGroupDetailsTitle: (title) => {
        return {
            type: ACTION_TYPES.SET_MAIN_MODULE_GROUP_DETAILS_TITLE,
            payload: {
                mainModuleGroupDetailsTitle: title
            }
        }
    },

    setMainModuleGroupDetails: (isCollapsed) => {
        return {
            type: ACTION_TYPES.SET_MAIN_MODULE_GROUP_DETAILS_IS_COLLAPSED,
            payload: {
                mainModuleGroupDetailsIsCollapsed: isCollapsed
            }
        }
    },

    setMainNavigationActiveMenuItemDomElementTop: (top) => {
        return {
            type: ACTION_TYPES.SET_MAIN_NAVIGATION_ACTIVE_MENU_ITEM_DOM_ELEMENT_TOP,
            payload: {
                mainNavigationActiveMenuItemDomElementTop: top
            }
        }
    },

    setFullscreenMode: (fullscreenModeIsActive) => {
        return {
            type: ACTION_TYPES.SET_FULLSCREEN_MODE,
            payload: {
                fullscreenModeIsActive: fullscreenModeIsActive
            }
        }
    }
}

export const layoutTemplateModularFullscreenReducer = (state = layoutTemplateModularFullscreenInitialState, action) => { // reminder: "initial state" must be returned as default case below
    switch(action.type) {
        case ACTION_TYPES.SET_MAIN_NAVIGATION_IS_COLLAPSED:
            // IMPORTANT: state is a ref(?), do not edit directly and then return
            return { // NEW state object
                ...state,
                mainNavigationIsCollapsed: action.payload.mainNavigationIsCollapsed
            };
        case ACTION_TYPES.SET_MAIN_NAVIGATION_ACTIVE_MENU_ITEM_ID:
            return {
                ...state,
                ...action.payload.allMenuStatesForActiveMenuItemId
            };
        case ACTION_TYPES.SET_MAIN_MODULE_GROUP_NAVIGATION_TITLE:
            return {
                ...state,
                mainModuleGroupNavigationTitle: action.payload.mainModuleGroupNavigationTitle
            };
        case ACTION_TYPES.SET_MAIN_MODULE_GROUP_NAVIGATION_IS_COLLAPSED:
            return {
                ...state,
                mainModuleGroupNavigationIsCollapsed: action.payload.mainModuleGroupNavigationIsCollapsed
            };
        case ACTION_TYPES.SET_MAIN_MODULE_GROUP_DETAILS_TITLE:
            return {
                ...state,
                mainModuleGroupDetailsTitle: action.payload.mainModuleGroupDetailsTitle
            };
        case ACTION_TYPES.SET_MAIN_MODULE_GROUP_DETAILS_IS_COLLAPSED:
            return {
                ...state,
                mainModuleGroupDetailsIsCollapsed: action.payload.mainModuleGroupDetailsIsCollapsed
            };
        case ACTION_TYPES.SET_MAIN_MODULE_GROUP_SELECTED_RESOURCE_TYPE:
            return {
                ...state,
                mainModuleGroupSelectedResourceType: action.payload.mainModuleGroupSelectedResourceType
            };
        case ACTION_TYPES.SET_MAIN_NAVIGATION_ACTIVE_MENU_ITEM_DOM_ELEMENT_TOP:
            return {
                ...state,
                mainNavigationActiveMenuItemDomElementTop: action.payload.mainNavigationActiveMenuItemDomElementTop
            };
        case ACTION_TYPES.SET_FULLSCREEN_MODE:
            return {
                ...state,
                fullscreenModeIsActive: action.payload.fullscreenModeIsActive
            }
        default:
            return state; // initial state
    }
}
